<script>
import { Errors } from 'form-backend-validation'
import { uniqBy } from 'lodash'
export default {
  name: 'studentScoreGrading',
  props: ['value', 'gradeSubjects', 'validate'],
  data() {
    return {
      errors: new Errors(),
      reload: false,
      subjects: [],
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    uniqueSubject() {
      return uniqBy(
        this.gradeSubjects.map(el => ({
          value: el.subject_id,
          label: el.subject_name_native
        })),
        'value'
      )
    }
  },
  methods: {},
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<template>
  <div v-if="!reload">
    <h3 class="ts-uppercase ts-font-semibold ts-text-blue-800 ts-text-base">
      {{ $t('studentTransfer.scoreGrading') }}
    </h3>

    <div
      class="ts-grid ts-grid-cols-1 lg:ts-grid-cols-2 xl:ts-grid-cols-4 ts-gap-2"
    >
      <div
        v-for="(scoreSubject, index) in model.scoreGrading"
        :key="index"
        class="ts-ml-2 ts-mt-2"
      >
        <div
          class="ts-border ts-w-full ts-p-1 ts-rounded ts-flex ts-whitespace-no-wrap ts-items-center ts-space-x-3"
        >
          <p class="ts-mb-0 ts-text-gray-500">
            {{ scoreSubject.subject_name_native }}
          </p>
          <i class="fas fa-arrow-right ts-text-xs ts-text-gray-500"></i>
          <div class="ts-w-full">
            <select
              v-model="scoreSubject.new_sc_subject_id"
              class="ts-outline-none ts-w-full"
            >
              <option value="">-</option>
              <option
                v-for="(subject, index) in uniqueSubject"
                :key="index"
                :value="subject.value"
                >{{ subject.label }}</option
              >
            </select>
            <div
              class="ts-text-red-500 ts-text-right"
              v-if="errors.has(`scoreGrading.${index}.new_sc_subject_id`)"
            >
              {{ errors.first(`scoreGrading.${index}.new_sc_subject_id`) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
